import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { SubitemContainer } from "./styles";
import { useMenu } from "../menuContext";
export var MenuSubitem = function (_a) {
    var subitem = _a.subitem, _b = _a.parentPath, parentPath = _b === void 0 ? "" : _b, setSearch = _a.setSearch, props = __rest(_a, ["subitem", "parentPath", "setSearch"]);
    var SubitemComponent = useMenu();
    var pathToGo = subitem.function ? "#" : parentPath + subitem.path || "#";
    return (_jsx(SubitemContainer, __assign({ as: SubitemComponent, to: pathToGo, id: "menu-item-".concat(subitem.path), isActive: pathToGo === window.location.pathname, onClick: function () {
            var _a;
            setSearch === null || setSearch === void 0 ? void 0 : setSearch("");
            (_a = subitem.function) === null || _a === void 0 ? void 0 : _a.call(subitem);
        } }, props, { children: _jsx("span", { children: subitem.searchText || subitem.text }) })));
};
//# sourceMappingURL=index.js.map